// extracted by mini-css-extract-plugin
export default {"PostTo":"InboxField__PostTo-qOkVn","Dropdown":"InboxField__Dropdown-GC9QZ"};